module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"post":"投稿する","error_occurred":"エラーが発生しました。","place_holder":"本文は140文字以内で入力してください。","add_comment":"コメントを追加しました。","post_tag_errMsg":"タグの投稿に失敗しました。<br>電波状況などが悪い可能性があります。<br>電波状況をご確認の上、再度お試しください。"}}')
  delete Component.options._Ctor
}
